import { render, staticRenderFns } from "./logisticsSearch.vue?vue&type=template&id=f612157e&scoped=true&"
import script from "./logisticsSearch.vue?vue&type=script&lang=js&"
export * from "./logisticsSearch.vue?vue&type=script&lang=js&"
import style0 from "./logisticsSearch.vue?vue&type=style&index=0&id=f612157e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f612157e",
  null
  
)

export default component.exports